import { render, staticRenderFns } from "./TagInfoDialog.vue?vue&type=template&id=807a0592&"
import script from "./TagInfoDialog.vue?vue&type=script&lang=js&"
export * from "./TagInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports